'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIAvatar = require('UIComponents/avatar/UIAvatar');

var _UIAvatar2 = _interopRequireDefault(_UIAvatar);

var _ie11OnlyStyle = require('ui-addon-messages/util/ie11OnlyStyle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizes = exports.sizes = {
  LARGE: 'large',
  DEFAULT: 'default'
};

var propTypes = {
  className: _react.PropTypes.string.isRequired,
  size: _react.PropTypes.string.isRequired,
  src: _react.PropTypes.string.isRequired
};

var defaultProps = {
  className: '',
  size: sizes.DEFAULT
};

var ChatAvatar = function (_Component) {
  _inherits(ChatAvatar, _Component);

  function ChatAvatar() {
    _classCallCheck(this, ChatAvatar);

    return _possibleConstructorReturn(this, (ChatAvatar.__proto__ || Object.getPrototypeOf(ChatAvatar)).apply(this, arguments));
  }

  _createClass(ChatAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          size = _props.size,
          src = _props.src;


      return _react2.default.createElement(_UIAvatar2.default, {
        className: className,
        size: size,
        source: 'ui-addon-messages',
        src: src,
        style: {
          height: (0, _ie11OnlyStyle.ie11OnlyStyle)('100%')
        }
      });
    }
  }]);

  return ChatAvatar;
}(_react.Component);

ChatAvatar.propTypes = propTypes;
ChatAvatar.defaultProps = defaultProps;

exports.default = ChatAvatar;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-messages/static-1.640/js/avatar/ChatAvatar.js
// module id = 495
// module chunks = 2 3